import React from "react";
import Cookies from "js-cookie";
import SwalAlert from "Global/Components/CommonComponents/SwalAlert/SwalAlert";
export const SetBaseData = (response, data) => {
  const cookieFn = (data) => {
    Cookies.set("user", JSON.stringify(data), {
      path: "/",
      expires: 3,
      sameSite: "strict",
      secure: window.top.location.protocol === "https:",
    });
  };

  if (response.data.resCode === 1) {
    if (Boolean(data.username) && Boolean(data.password)) {
      cookieFn(response.data.Data);
      localStorage.setItem("AuthToken", JSON.stringify(response.data.token));
    }
  } else {
    SwalAlert("error", response.data.resMessage, false);
  }
};
